import clsx from 'clsx'

export const Divider = ({ className }: { className?: string }) => {
  return <div className={clsx('rounded-[2px] w-full h-[1px] bg-[#e7eaee]', className)} role="none" />
}
